import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/base/Modal';
import { ReferenceSlokaCard } from './ReferenceSlokaCard';
import type { ReferenceSlokaItem } from '@/ayurveda/types/ayurveda';
import { BookOpen } from 'lucide-react';

interface ReferenceSlokasModalProps {
  slokas: ReferenceSlokaItem[];
}

export function ReferenceSlokasModal({ slokas = [] }: ReferenceSlokasModalProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          className="flex w-full items-center gap-2 rounded-lg border border-amber-200 bg-amber-50/50 px-3 py-2.5 text-left transition-colors hover:bg-amber-100/60"
          type="button"
        >
          <BookOpen size={18} className="shrink-0 text-amber-700" />
          <span className="font-hanken text-[15px] font-medium text-amber-800">
            View Ayurveda References
          </span>
          {slokas.length > 0 && (
            <span className="ml-auto rounded-full bg-amber-200 px-2 py-0.5 text-xs font-semibold text-amber-900">
              {slokas.length}
            </span>
          )}
        </button>
      </DialogTrigger>
      <DialogContent
        size="full"
        className="max-h-[90vh] w-[min(95vw,1100px)] overflow-y-auto overflow-x-hidden p-4 sm:p-6"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-hanken text-xl">
            <BookOpen size={22} className="text-amber-700" />
            Ayurveda Reference Slokas
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pr-1 pt-2">
          {slokas.length === 0 ? (
            <p className="py-8 text-center text-muted-foreground">
              No reference slokas available for this consultation.
            </p>
          ) : (
            slokas.map((sloka, idx) => (
              <ReferenceSlokaCard key={`sloka-${idx}`} sloka={sloka} index={idx} />
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
